import React, { useEffect, useState, useLayoutEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import {
  resetScreeningTypes,
  setOndemandShow,
} from '../../../store/movies/movieActions';
import { currencyFormatter } from '../../../helper/currencyFormatter';
import useIsMobile from '../../../customHooks/useIsMobile';
import SeatLayoutPopup from '../../partials/popups/SeatLayoutPopup';
import { fetchAudiSeatLayout } from '../../../store/ancilliary/ancilliaryActions';
// import RatingPopup from '@components/partials/popups/RatingPopup';
import { ReactComponent as Dx } from '@assets/pictures/svgs/4dx.svg';
import AfterMidnight from '@assets/pictures/Aftmid.png';

const BookingShows = (props) => {
  const {
    t,
    classes,
    screen,
    format,
    cinema,
    formatIndex,
    screenIndex,
    cinemaIndex,
    onClickShowMobile,
    isPrivate,
    allLangWithSubs = false,
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const currency = useSelector((state) => state.movies.currency);
  const { curr_code, curr_id } = currency;
  let userSelection = useSelector((state) => state.movies.userSelection);

  const selectedCinema = useSelector((state) => state.movies.selectedCinema);
  // console.log(selectedCinema, 'selectedCinema');
  let cinema_id = selectedCinema?.cinema_id;

  const [schedules, setSchedules] = useState([]);

  const [schedulesAfterMidnight, setSchedulesAfterMidnight] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  // const [ratingPopup, setratingPopup] = useState(false);

  useLayoutEffect(() => {
    let isApiGotSessions = !!screen?.schedule_list?.[0]?.show_timing_label;

    let filteredSchedules = [];
    let filteredAfterMidnightSchedules = screen?.schedule_list_after_midnight ?? [];
    let sortedSch = screen?.schedule_list;

    if (isApiGotSessions) {
      sortedSch.sort((a, b) => {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.date_final_output) - new Date(b.date_final_output);
      });
    }
    if (filteredAfterMidnightSchedules) {
      filteredAfterMidnightSchedules.sort((a, b) => {
        return new Date(a.date_final_output) - new Date(b.date_final_output);
      });
    }
    if (userSelection?.selectedSession) {
      if (isApiGotSessions) {
        filteredSchedules = sortedSch.filter(
          (s) => s?.show_timing_label === userSelection?.selectedSession?.label,
        );
      } else
        sortedSch.forEach((s) => {
          if (
            moment()
              .add(s.showTime)
              .isBetween(
                moment().add(userSelection.selectedSession.from),
                moment().add(userSelection.selectedSession.to),
              )
          ) {
            filteredSchedules.push(s);
          }
        });
    } else filteredSchedules = sortedSch;

    setSchedules(filteredSchedules);
    setSchedulesAfterMidnight(filteredAfterMidnightSchedules || []);
  }, [screen, userSelection.selectedSession]);

  let price = screen?.schedule_list
    .flatMap((sc) => sc?.priceArray.flatMap((p) => p))
    .sort((a, b) => a?.pricing - b?.pricing)?.[0]?.pricing;
  let showPriceIsPrivate =
    screen?.schedule_list
      .flatMap((sc) => sc?.priceArray.flatMap((p) => p))
      .sort((a, b) => a?.pricing - b?.pricing)?.[0]?.isPrivate ?? false;

  if (!isPrivate) {
    price = screen?.schedule_list
      .flatMap((sc) => sc?.priceArray.filter((p) => p?.pricing).flatMap((p) => p))
      .sort((a, b) => a?.pricing - b?.pricing)?.[0]?.pricing;
  }

  // var isTouch
  // if (typeof document !== 'undefined') {
  //   isTouch = 'ontouchstart' in document.documentElement;
  // }
  const [loader, setLoader] = useState(false);
  const [popUpSeatLayout, setPopupSetSeatLayout] = useState(false);
  const onClickAudiCard = (screen_id) => {
    if (screen_id) {
      setLoader(true);
      dispatch(fetchAudiSeatLayout({ screen_id: screen_id, callback: setLoader }))
        .then(() => {
          // setPopupSetSeatLayout(true)
        })
        .finally(() => {
          // setLoader(false)
        });
    }
  };

  if (schedules?.length === 0 && schedulesAfterMidnight?.length === 0) return <></>;
  return (
    <>
      {/* {ratingPopup && (
        <RatingPopup
          show={ratingPopup}
          closeFunc={(flag) => {
            setratingPopup(!!flag);
          }}
          // screen={screen}
          // format={format}
          // onClickShowMobile={onClickShowMobile}
        />
      )} */}
      <SeatLayoutPopup
        show={popUpSeatLayout}
        closeFunc={setPopupSetSeatLayout}
        loader={loader}
      />
      <div className="booking_shows_wrapper">
        <article
          className={`${
            isPrivate
              ? ' booking_shows_screen_n_price_golden'
              : ' booking_shows_screen_n_price'
          }`}
        >
          {/*<h5>{screen?.screen_name} - {format?.versionDataFallback || format?.version_name}</h5>*/}

          <h5>
            <span style={{ color: '#1f1c3c' }}>{cinema?.cinema_name}</span>
          </h5>

          <h5>
            <span
              style={{ color: '#1f1c3c' }}
              onClick={() => {
                // history.push(`/cinema-listing`)
                // if (!!cinema_id) {
                //   history.push(`/cinema-details/${cinema_id}`)
                // }
                if (screen?.screen_id) {
                  setPopupSetSeatLayout(true);
                  onClickAudiCard(screen?.screen_id);
                }
              }}
            >
              {screen?.screen_name}
            </span>
            {(format?.version_name ||
              format?.versionDataFallback ||
              format?.movie_lang_iso_3) && (
              <h4>
                (
                {format?.version_name ||
                  format?.versionDataFallback ||
                  format?.movie_lang_iso_3}
                )
              </h4>
            )}
            {allLangWithSubs && isPrivate && (
              <h4 className={'isprivate'}>
                (
                {`${!!format?.movie_lang_iso_3 ? format?.movie_lang_iso_3 : ''}${
                  !!format?.sub_1_iso_2 ? `/${format?.sub_1_iso_2}` : ''
                }${
                  !!format?.sub_1_iso_2 && !!format?.sub_2_iso_2
                    ? `-${format?.sub_2_iso_2}`
                    : ''
                }`}
                )
              </h4>
            )}
            {/*{!isPrivate && (<h4 className={'!isprivate'}>({
              `${!!format?.movie_lang_iso_3 ? format?.movie_lang_iso_3 : ''}${
                !!format?.sub_lang_1_iso_2 ? `/${format?.sub_lang_1_iso_2}` : ''
              }${
                !!format?.sub_lang_1_iso_2 && !!format?.sub_lang_2_iso_2 ? `-${format?.sub_lang_2_iso_2}` : ''
              }`
            })</h4>)}*/}
          </h5>

          {price > 0 && !showPriceIsPrivate && false && (
            <h6>
              {t('Starts at')} {curr_code} {currencyFormatter(price)}
            </h6>
          )}
        </article>
        <div className="d-block">
          <article className="booking_shows">
            {schedules?.map((show, index) => (
              <React.Fragment key={index}>
                <div
                  className={`movie-card__tooltip__wrapper ${
                    show.statusTypeNew == 'Fully Booked' ||
                    show?.ocuupancyPercentage == 100
                      ? 'inactive'
                      : ''
                  } ${
                    userSelection?.selectedScreen?.screen_id ===
                      screen?.screen_id &&
                    userSelection?.selectedMovieVersion?.movie_details_id ===
                      format?.movie_details_id &&
                    userSelection?.selectedShow?.ss_actual_start_date_time ===
                      show?.ss_actual_start_date_time
                      ? 'active__'
                      : ''
                  }
                       ${
                         show?.mf_name && show?.mf_name.toLowerCase() !== '2d'
                           ? 'with_format'
                           : ''
                       }
                    `}
                  style={{
                    cursor: 'pointer',
                    height: '38px',
                    margin: isMobile ? '5px' : undefined,
                  }}
                  onClick={
                    // isTouch ? undefined :
                    () => {
                      // setratingPopup(true);
                      if (show.statusTypeNew == 'Fully Booked') {
                        console.log('statusType', show.statusType);
                        return;
                      }

                      dispatch(resetScreeningTypes());
                      dispatch(
                        setOndemandShow({ show, screen, movieVersion: format }),
                      ).then(() => {
                        setTimeout(() => {
                          onClickShowMobile({ show, screen, movieVersion: format });
                        }, 0);
                      });
                      // if (isMobile) {
                      // }
                    }
                  }
                  // onTouchStart={
                  //   !isTouch ? undefined :
                  //   () => {
                  //   if (isMobile) {
                  //     console.log('onTouchStart')
                  //     dispatch(resetScreeningTypes())
                  //     dispatch(setOndemandShow({show, screen, movieVersion: format}))
                  //     setTimeout(() => {
                  //       onClickShowMobile()
                  //     }, 400)
                  //   }
                  // }}
                >
                  <div
                    className={`occupany_slider ${
                      show?.ocuupancyPercentage >= 50 &&
                      show?.ocuupancyPercentage < 100
                        ? 'bgOrange'
                        : show?.ocuupancyPercentage >= 100
                        ? 'bgRed'
                        : ''
                    }`}
                    style={{
                      width:
                        show?.ocuupancyPercentage > 0 &&
                        show?.ocuupancyPercentage <= 49
                          ? '30%'
                          : show?.ocuupancyPercentage >= 50 &&
                            show?.ocuupancyPercentage <= 80
                          ? '50%'
                          : show?.ocuupancyPercentage >= 81 &&
                            show?.ocuupancyPercentage < 100
                          ? '90%'
                          : show?.ocuupancyPercentage > 99 &&
                            show?.ocuupancyPercentage >= 100
                          ? '100%'
                          : '0',
                    }}
                  ></div>
                  <div
                    className="show-btn yellow lg green "
                    style={{ zIndex: '1' }}
                  >
                    <p
                      className="show-time-flow"
                      style={{
                        marginTop:
                          !!show?.mf_name && show?.mf_name?.toLowerCase() !== '2d'
                            ? undefined
                            : 'unset',
                        color: show?.ocuupancyPercentage >= 100 ? '#fff' : '',
                      }}
                    >
                      {/* {moment(show?.showTime).format('hh:mm A')} */}
                      {moment(show?.date_final_output).format('hh:mm A')}

                      {/* show?.total_no_seat */}
                    </p>
                    {show?.mf_name && show?.mf_name.toLowerCase() !== '2d' && (
                      <button className="three_d">
                        {show?.mf_name.toLowerCase() == '4dx' ? (
                          <Dx />
                        ) : (
                          show?.mf_name
                        )}
                      </button>
                    )}
                  </div>

                  {false &&
                    show?.mf_name &&
                    show?.mf_name.toLowerCase() !== '2d' && (
                      <span>{show?.mf_name}</span>
                    )}
                  {show.statusTypeNew == 'Fully Booked' && (
                    <article className="movie-card__tooltip text-uppercase">
                      <p style={{ width: isMobile ? undefined : 'max-content' }}>
                        {t(show.statusTypeNew)}
                      </p>
                    </article>
                  )}
                </div>
              </React.Fragment>
            ))}
          </article>

          {/* After Midnight Section Stars*/}
          {schedulesAfterMidnight?.length > 0 && (
            <>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minWidth: '300px' }}
              >
                <div style={{ width: '36%' }}>
                  <hr className="midnight_hr" />
                </div>
                {/* <hr className="divider" style={{ marginLeft: '0px' }} /> */}
                <img src={AfterMidnight} className="custom_after_mid_img" />
                <span className="aftermid_date">
                  {schedulesAfterMidnight && schedulesAfterMidnight?.length > 0
                    ? moment(
                        schedulesAfterMidnight[0]?.ss_actual_start_date,
                      ).format('DD MMM YYYY dddd')
                    : ''}
                </span>

                {false && (
                  <h6
                    className="mid_night_text px-2 align-items-center font-weight-bold"
                    style={{
                      borderLeft: '0px',
                    }}
                  >
                    {/* <hr className="transform_hr" /> */}
                    {t('After Midnight')}
                  </h6>
                )}
                <div style={{ width: '36%' }}>
                  <hr className="midnight_hr" />
                </div>
              </div>
            </>
          )}

          {schedulesAfterMidnight?.length > 0 && (
            <article className="booking_shows">
              {schedulesAfterMidnight?.map((show, index) => (
                <React.Fragment key={index}>
                  <div
                    className={`movie-card__tooltip__wrapper ${
                      show.statusTypeNew == 'Fully Booked' ||
                      show?.ocuupancyPercentage == 100
                        ? 'inactive'
                        : ''
                    } ${
                      userSelection?.selectedScreen?.screen_id ===
                        screen?.screen_id &&
                      userSelection?.selectedMovieVersion?.movie_details_id ===
                        format?.movie_details_id &&
                      userSelection?.selectedShow?.ss_actual_start_date_time ===
                        show?.ss_actual_start_date_time
                        ? 'active__'
                        : ''
                    }
                       ${
                         show?.mf_name && show?.mf_name.toLowerCase() !== '2d'
                           ? 'with_format'
                           : ''
                       }
                    `}
                    style={{
                      cursor: 'pointer',
                      height: '38px',
                      margin: isMobile ? '5px' : undefined,
                    }}
                    onClick={
                      // isTouch ? undefined :
                      () => {
                        // setratingPopup(true);
                        if (show.statusTypeNew == 'Fully Booked') {
                          console.log('statusType', show.statusType);
                          return;
                        }

                        dispatch(resetScreeningTypes());
                        dispatch(
                          setOndemandShow({ show, screen, movieVersion: format }),
                        ).then(() => {
                          setTimeout(() => {
                            onClickShowMobile({
                              show,
                              screen,
                              movieVersion: format,
                            });
                          }, 0);
                        });
                        // if (isMobile) {
                        // }
                      }
                    }
                    // onTouchStart={
                    //   !isTouch ? undefined :
                    //   () => {
                    //   if (isMobile) {
                    //     console.log('onTouchStart')
                    //     dispatch(resetScreeningTypes())
                    //     dispatch(setOndemandShow({show, screen, movieVersion: format}))
                    //     setTimeout(() => {
                    //       onClickShowMobile()
                    //     }, 400)
                    //   }
                    // }}
                  >
                    <div
                      className={`occupany_slider ${
                        show?.ocuupancyPercentage >= 50 &&
                        show?.ocuupancyPercentage < 100
                          ? 'bgOrange'
                          : show?.ocuupancyPercentage >= 100
                          ? 'bgRed'
                          : ''
                      }`}
                      style={{
                        width:
                          show?.ocuupancyPercentage > 0 &&
                          show?.ocuupancyPercentage <= 49
                            ? '30%'
                            : show?.ocuupancyPercentage >= 50 &&
                              show?.ocuupancyPercentage <= 80
                            ? '50%'
                            : show?.ocuupancyPercentage >= 81 &&
                              show?.ocuupancyPercentage < 100
                            ? '90%'
                            : show?.ocuupancyPercentage > 99 &&
                              show?.ocuupancyPercentage >= 100
                            ? '100%'
                            : '0',
                      }}
                    ></div>
                    <div
                      className="show-btn yellow lg green"
                      style={{ zIndex: '1' }}
                    >
                      <p
                        className="show-time-flow"
                        style={{
                          marginTop:
                            !!show?.mf_name && show?.mf_name?.toLowerCase() !== '2d'
                              ? undefined
                              : 'unset',
                        }}
                      >
                        {/* {show?.showTime} */}
                        {moment(show?.date_final_output).format('hh:mm A')}
                      </p>
                      {show?.mf_name && show?.mf_name.toLowerCase() !== '2d' && (
                        <button className="three_d">
                          {show?.mf_name.toLowerCase() == '4dx' ? (
                            <Dx />
                          ) : (
                            show?.mf_name
                          )}
                        </button>
                      )}
                    </div>

                    {false &&
                      show?.mf_name &&
                      show?.mf_name.toLowerCase() !== '2d' && (
                        <span>{show?.mf_name}</span>
                      )}
                    {show.statusTypeNew == 'Fully Booked' && (
                      <article className="movie-card__tooltip text-uppercase">
                        <p style={{ width: isMobile ? undefined : 'max-content' }}>
                          {show?.statusType}
                        </p>
                      </article>
                    )}
                  </div>
                </React.Fragment>
              ))}
            </article>
          )}
        </div>

        {schedules?.length === 0 && schedulesAfterMidnight?.length === 0 && (
          <>
            <div className="row">
              <div className="col-12 text-center">
                <p className="no-result">
                  {t('sorry-on-this-date-private-ondemand-not-available')}
                </p>
              </div>
            </div>
          </>
        )}
      </div>

      {/*<div>
        <button>Golden</button>
      </div>*/}

      {showTooltip && (
        <div
          className="booking-unavailable-tooltip"
          style={{
            position: 'fixed',
            left: `${tooltipPosition.x}px`,
            top: `${tooltipPosition.y}px`,
            transform: 'translateX(-50%) translateY(-100%)',
            zIndex: 9999,
            backgroundColor: '#fff',
            border: '2px solid #4CAF50',
            borderRadius: '8px',
            padding: '15px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            maxWidth: '350px',
            fontSize: '14px',
            lineHeight: '1.4',
            color: '#333',
          }}
          onClick={() => setShowTooltip(false)}
        >
          <div style={{ textAlign: 'center' }}>
            <p style={{ margin: '0 0 10px 0', fontWeight: '600' }}>
              Online booking is currently unavailable.
            </p>
            <p style={{ margin: '0 0 10px 0', fontSize: '13px', color: '#666' }}>
              In the meantime, tickets can be purchased directly at the box office.
              We appreciate your understanding and look forward to welcoming you
              soon.
            </p>
            <p
              className="text-center font-weight-bold"
              style={{ margin: '0 0 10px 0' }}
            >
              Ticket Price
            </p>
            <div className="d-flex justify-content-between align-items-center">
              <p>Star Select - 3.00 OMR</p>
              <p>Star Plus - 3.02 OMR</p>
            </div>
          </div>
          {/* Close button */}
          <button
            onClick={() => setShowTooltip(false)}
            style={{
              position: 'absolute',
              top: '5px',
              right: '8px',
              background: 'transparent',
              border: 'none',
              fontSize: '18px',
              cursor: 'pointer',
              color: '#999',
            }}
          >
            ×
          </button>
        </div>
      )}

      {showTooltip && (
        <div
          className="tooltip-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.1)',
            zIndex: 9998,
          }}
          onClick={() => setShowTooltip(false)}
        />
      )}
    </>
  );
};

export default withNamespaces()(BookingShows);
